
const ModoMantenimientoView = () =>
  import('../../../statics/views/ModoMantenimientoView.vue');

export default [
  {
    path: '/ModoMantenimientoView',
    name: 'ModoMantenimientoView',
    component: ModoMantenimientoView,
    meta: {
      title: 'Buscador de Pantallas',
      requiresAuthentication: false,
      requiresAuthorization: false,
      //   isSlim: true,
      bread: {
        path: [
          'Error',
        ],
      },
    },
  },
];
